export const es = {
  hero: {
    title: "Opera <span>Más Inteligente</span> con Phemex + METRADE",
    subtitle: "Estrategias de trading profesionales ahora accesibles para todos",
    startTrading: "Regístrate Gratis",
    signUpForFree: "Regístrate Gratis",
    learnMore: "Aprende Más Sobre Phemex",
    poweredBy: "Desarrollado por",
    socialProof: "Únete a más de 40,000 traders"
  },
  promo: {
    signUp: "Regístrate hoy y obtén",
    months: "3 MESES GRATIS",
    worth: "Valor de 3x29$ • Ahorra 87$",
    limitedTime: "¡Oferta por tiempo limitado! Expira pronto"
  },
  whyMetrade: {
    title: "Por Qué Elegir METRADE",
    subtitle: "El compañero perfecto para tu viaje de trading en Phemex",
    reason1: {
      title: "Estrategias Verificadas",
      description: "Todas las estrategias premium tienen historiales probados y están rigurosamente evaluadas"
    },
    reason2: {
      title: "Gestión de Riesgos",
      description: "Controles de riesgo avanzados integrados en cada estrategia premium para proteger tu capital"
    },
    reason3: {
      title: "Calidad Suiza",
      description: "Construido en Suiza con precisión, fiabilidad y seguridad"
    },
    reason4: {
      title: "Integración Sencilla",
      description: "Siga la estrategia en su cuenta de Phemex sin necesidad de conocimientos técnicos"
    },
    reason5: {
      title: "Transparencia Total",
      description: "Accede a datos de rendimiento en tiempo real e historial de trading completo"
    },
    reason6: {
      title: "Soporte Experto",
      description: "Equipo dedicado de profesionales de trading listos para ayudarte"
    }
  },
  steps: {
    title: "Comienza Tu Viaje de Trading",
    subtitle: "Empieza con tres simples pasos",
    step1: {
      title: "Regístrate gratis",
      description: "Crea tu cuenta en segundos con solo tu correo electrónico"
    },
    step2: {
      title: "Selecciona una Estrategia",
      description: "Explora estrategias diseñadas específicamente para traders de Phemex"
    },
    step3: {
      title: "Conecta y Comienza",
      description: "Selecciona tu estrategia con nuestra configuración guiada y comienza a operar"
    },
    joinText: "Únete a miles de usuarios exitosos en METRADE"
  },
  stats: {
    title: "Rendimiento Probado",
    subtitle: "Nuestra plataforma ofrece resultados consistentes para traders en todo el mundo",
    activeUsers: "Usuarios Activos en más de 100 países",
    tradingVolume: "Volumen de Trading procesado diariamente",
    successRate: "Tasa de satisfacción de las encuestas",
    support: "Soporte Prioritario con múltiples idiomas"
  },
  features: {
    title: "METRADE Marketplace",
    subtitle: "Únete a miles de usuarios exitosos que han transformado su experiencia de trading",
    feature1: {
      title: "Estrategias Probadas",
      description: "Accede a estrategias de trading probadas con tasas de éxito verificadas de hasta el 95%"
    },
    feature2: {
      title: "Gestión de Riesgos",
      description: "Los parámetros de riesgo preestablecidos protegen tu capital durante la volatilidad del mercado"
    },
    feature3: {
      title: "Integración Sencilla",
      description: "Conecta tu cuenta de Phemex en menos de 2 minutos con una configuración guiada"
    },
    feature4: {
      title: "Basado en Datos",
      description: "Toma decisiones informadas con análisis de rendimiento en tiempo real"
    }
  },
  strategyShowcase: {
    title: "Estrategias de Mayor Rendimiento",
    subtitle: "Descubre nuestras estrategias de trading más exitosas disponibles en Phemex",
    viewAll: "Ver Todas las Estrategias",
    strategy1: {
      name: "Maestro del Impulso",
      description: "Captura las tendencias del mercado con puntos de entrada y salida precisos",
      roi: "+175% ROI en 2023",
      winRate: "76% Tasa de Ganancia",
      riskLevel: "Riesgo Medio"
    },
    strategy2: {
      name: "Ventaja de la Volatilidad",
      description: "Prospera en mercados volátiles con parámetros de trading adaptativos",
      roi: "+205% ROI en 2023",
      winRate: "81% Tasa de Ganancia",
      riskLevel: "Riesgo Medio-Alto"
    },
    strategy3: {
      name: "Crecimiento Constante",
      description: "Enfoque conservador centrado en retornos consistentes",
      roi: "+90% ROI en 2023",
      winRate: "89% Tasa de Ganancia",
      riskLevel: "Riesgo Bajo"
    },
    phemexCompatible: "Optimizado para Phemex"
  },
  testimonials: {
    title: "Historias de Éxito",
    subtitle: "Escucha a traders que ya se están beneficiando de nuestras estrategias",
    testimonial1: {
      quote: "He probado múltiples plataformas de copy trading, pero la integración de METRADE con Phemex es, con diferencia, la más fluida. Mis retornos han aumentado un 43% desde que empecé.",
      author: "Michael T.",
      location: "Reino Unido",
      strategy: ""
    },
    testimonial2: {
      quote: "Como trader principiante, estaba perdiendo dinero constantemente. Con las estrategias de METRADE en Phemex, finalmente estoy viendo resultados positivos sin pasar horas en los gráficos.",
      author: "Sarah K.",
      location: "Singapur",
      strategy: ""
    },
    testimonial3: {
      quote: "La transparencia es lo que más me impresionó. Puedo ver exactamente cómo están funcionando mis estrategias y los controles de riesgo han salvado mi capital durante las recientes caídas del mercado.",
      author: "Alex D.",
      location: "Alemania",
      strategy: ""
    }
  },
  faq: {
    title: "Preguntas Frecuentes",
    subtitle: "Encuentra respuestas a preguntas comunes sobre la integración de METRADE y Phemex",
    question1: {
      question: "¿Cómo funciona la integración Phemex-METRADE?",
      answer: "Nuestra plataforma se conecta a tu cuenta de Phemex a través de claves API seguras con permisos solo de trading. Una vez conectado, las estrategias que selecciones ejecutarán automáticamente operaciones en tu nombre basadas en parámetros predefinidos."
    },
    question2: {
      question: "¿Cuál es el capital mínimo requerido para empezar?",
      answer: "El mínimo es 1800 USDT para una Estrategia Gratuita. El mínimo de 2300 USDT es una Estrategia Premium con Gestión de Riesgos."
    },
    question3: {
      question: "¿Cómo puedo monitorear y controlar mi riesgo?",
      answer: "Cada estrategia viene con configuraciones de gestión de riesgos integradas que puedes revisar antes de activar. Puedes establecer límites máximos de reducción y nuestra plataforma detendrá automáticamente el trading si se alcanzan estos límites."
    },
    question4: {
      question: "¿Puedo personalizar las estrategias de trading?",
      answer: "Sí, los usuarios premium pueden ajustar ciertos parámetros de las estrategias, incluyendo el tamaño de la posición, el número máximo de operaciones concurrentes y los niveles de tolerancia al riesgo. Nuestros planes básicos ofrecen estrategias preconfiguradas."
    },
    question5: {
      question: "¿Qué pasa si quiero dejar de usar una estrategia?",
      answer: "Puedes pausar o desconectar una estrategia en cualquier momento con un solo clic. Esto detendrá inmediatamente cualquier nueva operación, mientras te da opciones para gestionar las posiciones abiertas existentes."
    },
    question6: {
      question: "¿Hay tarifas ocultas?",
      answer: "No. Cobramos una tarifa de suscripción mensual transparente basada en el plan que elijas. No hay comisiones adicionales sobre las ganancias ni cargos ocultos. Solo pagas las tarifas de trading estándar de Phemex."
    }
  },
  footer: {
    copyright: "Todos los derechos reservados."
  },
  languageSelector: {
    language: "Idioma"
  },
  cta: {
    title: "¿Listo para transformar tu trading?",
    subtitle: "Comienza con una prueba gratuita de 3 meses hoy",
    buttonText: "Regístrate Gratis",
    noCredit: "No se requiere tarjeta de crédito para la prueba gratuita"
  }
};
